import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { deleteData, getAllOrganisationData } from '../utils/api/organisationAPI';
import { toast } from 'sonner';
import ConfirmDeleteModal from './child/ConfirmDeleteModal';
import { motion } from 'framer-motion';
import { convertToIndianTimeZone } from '../utils/utils';

const OrganisationListLayer = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [organisationToDelete, setOrganisationToDelete] = useState(null);
    const navigate = useNavigate();

    // function on click on view button 
    const handleViewClick = (id) => {
        navigate(`/organisation/view/${id}`);
    };

    // function on click on edit button 
    const handleEditClick = (id) => {
        navigate(`/organisation/edit/${id}`);
    };

    useEffect(() => {
        async function fetchData() {
            // Tell the shimmer to show
            setIsLoading(true);
            try {
                const response = await getAllOrganisationData({ setIsLoading });
                setData(response?.organizations || []);
            } catch (e) {
                console.error(e);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    // Handle the delete button click
    const handleDeleteClick = (organisationId) => {
        setOrganisationToDelete(organisationId);
        setShowModal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const response = await deleteData(organisationToDelete);
            toast.success(response?.message || "Organisation deleted successfully.");
            setShowModal(false);
            setOrganisationToDelete(null);
        } catch (error) {
            toast.error(error.message);
            console.error("Delete error:", error.message);
            setShowModal(false);
        }
    };

    // Handle the cancel delete action
    const handleCancelDelete = () => {
        setShowModal(false);
    };

    return (
        <motion.div
            initial={{
                opacity: 0
            }}
            animate={{
                opacity: 1
            }}
            transition={{
                duration: 1
            }}
            className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                <div className="d-flex align-items-center flex-wrap gap-3">
                    {/* <form className="navbar-search">
                        <input
                            type="text"
                            className="bg-base h-40-px w-auto"
                            name="search"
                            placeholder="Search"
                        />
                        <Icon icon="ion:search-outline" className="icon" />
                    </form> */}
                </div>
                <Link
                    to="/add-organisation"
                    className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                >
                    <Icon
                        icon="ic:baseline-plus"
                        className="icon text-xl line-height-1"
                    />
                    Add New Organisation
                </Link>
            </div>

            <div className="card-body p-24">
                <div className="table-responsive scroll-sm">
                    <table className="table bordered-table sm-table mb-0">
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    className="text-center"
                                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                >
                                    ID
                                </th>
                                <th
                                    scope="col"
                                    className=""
                                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                >
                                    Org Name
                                </th>
                                <th
                                    scope="col"
                                    className=""
                                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                >
                                    Minute Used
                                </th>
                                
                                <th
                                    scope="col"
                                    className=""
                                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                >
                                    Created At
                                </th>
                                <th
                                    scope="col"
                                    className=""
                                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                >
                                    Subscription
                                </th>
                                <th
                                    scope="col"
                                    className="text-center"
                                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                >
                                    Status
                                </th>
                                <th
                                    scope="col"
                                    className="text-center"
                                    style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                >
                                    Action
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {isLoading ? (
                                Array.from({ length: 7 }).map((_, idx) => (
                                    <tr key={`shimmer-row-${idx}`}>
                                        <td
                                            className="text-center"
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            <div className="shimmer shimmer-id" />
                                        </td>
                                        <td
                                            className="text-center"
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            <div className="shimmer shimmer-text" />
                                        </td>
                                        <td
                                            className="text-center"
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            <div className="shimmer shimmer-text" />
                                        </td>
                                        <td
                                            className="text-center"
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            <div className="shimmer shimmer-text" />
                                        </td>
                                        <td
                                            className="text-center"
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            <div className="shimmer shimmer-badge" />
                                        </td>
                                        <td
                                            className="text-center"
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            <div className="shimmer shimmer-badge" />
                                        </td>
                                        <td
                                            className="text-center"
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            <div className="shimmer shimmer-actions" />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                data.map((item) => (
                                    <tr key={item.id}>
                                        <td
                                            className="text-center"
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            <div className="d-flex align-items-center gap-10">{item?.id}</div>
                                        </td>
                                        <td
                                            className=""
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1">
                                                    <span className="text-md mb-0 fw-normal text-secondary-light">
                                                        {item.name}
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                        <td
                                                className=""
                                                style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                            >
                                                <span className="text-md mb-0 fw-normal text-secondary-light">
                                                    {item.minutesUsed} minutes
                                                </span>
                                            </td>
                                            <td
                                            className=""
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            {convertToIndianTimeZone(item.createdAt)}
                                        </td>
                                        <td
                                            className=""
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            {item.isSubscribed ? (
                                                <span className="badge text-sm fw-semibold text-success-600 bg-success-100 px-20 py-9 radius-4 text-white">
                                                    Active
                                                </span>
                                            ) : (
                                                <span className="badge text-sm fw-semibold text-danger-600 bg-danger-100 px-20 py-9 radius-4 text-white">
                                                    InActive
                                                </span>
                                            )}
                                        </td>
                                        <td
                                            className="text-center"
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            {item.status ? (
                                                <span className="badge text-sm fw-semibold text-success-600 bg-success-100 px-20 py-9 radius-4 text-white">
                                                    Active
                                                </span>
                                            ) : (
                                                <span className="badge text-sm fw-semibold text-danger-600 bg-danger-100 px-20 py-9 radius-4 text-white">
                                                    InActive
                                                </span>
                                            )}
                                        </td>
                                        <td
                                            className="text-center"
                                            style={{ textAlign: 'center', verticalAlign: 'middle' }}
                                        >
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                <button
                                                    type="button"
                                                    onClick={() => handleViewClick(item.id)}
                                                    className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon icon="majesticons:eye-line" className="icon text-xl" />
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => handleEditClick(item.id)}
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                </button>
                                                <button
                                                    type="button"
                                                    className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleDeleteClick(item.id)}
                                                >
                                                    <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Modal for Delete Confirmation */}
                {showModal && (
                    <ConfirmDeleteModal
                        name={data.find((org) => org.id === organisationToDelete)?.name}
                        isOrganisation={true}
                        handleConfirmDelete={handleConfirmDelete}
                        handleCancelDelete={handleCancelDelete}
                    />
                )}
            </div>

        </motion.div>
    );
};

export default OrganisationListLayer;
